import { Card, Col, Row } from 'antd'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import ShopifyIcon from '@Icons/shopify-icon-2.svg?react'
import { useMeQuery } from '@Store/api'
import {
  useDataManagementActions,
  useDataManagementState,
} from '@Store/slices/dataManagementSlice'
import scrollToId from '@Utils/helpers/scroll-to-id'

import RecentImports from './file-import/RecentImports'
import SelectionCard from './SelectionCard'
import { type ProductSource } from '../types/product'
import { getShopifyProductSources } from '../utils/product'
import EditBatchProductSource from './product/manual/EditBatchProductSource'

function ProductSourceShopify(): JSX.Element {
  const navigate = useNavigate()

  const { data: meData } = useMeQuery()

  const { selectedProductSource } = useDataManagementState()
  const { setSelectedProductSource } = useDataManagementActions()

  const handleClickSource = (source: ProductSource) => {
    setSelectedProductSource(source)

    if (source.id === 'import') {
      navigate('shopify-import')

      return
    }
  }

  useEffect(() => {
    if (selectedProductSource?.id === 'update') {
      scrollToId('selected_product_management')
    }
  }, [selectedProductSource])

  return (
    <>
      <Card
        title={
          <>
            <h1 className="pb-2 text-xl text-gray-900 font-medium flex flex-row items-center">
              <ShopifyIcon className="w-[36px] h-[36px] p-[4px] mr-1" /> Shopify
              Integration
            </h1>
            <p className="pr-2 font-normal text-base text-gray-500 mb-4">
              Your Shopify store <b>{meData?.url}</b> is connected. Import
              products or update existing entries.
            </p>
          </>
        }
        className="pt-4"
      >
        <Row justify="center" gutter={[24, 24]}>
          {getShopifyProductSources().map((source: ProductSource) => (
            <Col xs={24} md={12} key={source.id}>
              <SelectionCard
                isActive={selectedProductSource?.id === source.id}
                showCheckbox={false}
                titleElement={
                  <h2 className="text-primary-800 text-base font-semibold leading-8 mb-2 flex flex-row items-center">
                    <span className="mr-3">{source.icon}</span>
                    {source.title}
                  </h2>
                }
                descriptionElement={
                  <div className="flex flex-col flex-1 pt-2 pb-2">
                    <p className="font-normal text-base text-start text-gray-500">
                      {source.description}
                    </p>
                  </div>
                }
                className="hover:border-primary-600 transition-all [&>div>.link-icon]:hover:translate-x-1"
                onClick={() => handleClickSource(source)}
                linkButtonLabel={source.button}
                onLinkButtonClick={source.onButtonClick}
              />
            </Col>
          ))}
        </Row>
      </Card>
      {selectedProductSource?.id === 'update' && (
        <div id="selected_product_management" className="pt-8">
          <EditBatchProductSource />
        </div>
      )}
      <RecentImports type={['apt', 'upt']} />
    </>
  )
}

export default ProductSourceShopify
